<nav class="navbar navbar-expand-lg main-navbar sticky">
  <div class="form-inline me-auto">
    <ul class="navbar-nav msr-3">
      <li>
                <a (click)="mobileMenuSidebarOpen($event,'overlay-open')" class="nav-link nav-link-lg
									collapse-btn" data-toggle="sidebar">
          <i-feather name="menu"></i-feather>
        </a>
      </li>
      <!--      <li>-->
      <!--        <form class="form-inline me-auto">-->
      <!--          <div class="search-element d-flex">-->
      <!--            <input class="form-control" type="search" placeholder="{{'HEADER.SEARCH.TEXT' | translate}}"-->
      <!--              aria-label="Search" data-width="200">-->
      <!--            <button class="btn" type="submit">-->
      <!--              <i class="fas fa-search"></i>-->
    <!--            </button>-->
  <!--          </div>-->
<!--        </form>-->
<!--      </li>-->
<li>
  <div class="header-logo-container">
    <a routerLink="/dashboard"> <img alt="image" class="header-logo" src="assets/images/logo.png"/>
      <!-- <span class="logo-name">{{APP_CONSTANTS.APP_NAME}}</span> -->
    </a>
  </div>
</li>
<li></li>
</ul>
</div>
<ul class="navbar-nav navbar-right">
  <li>
    <div class="nav-link nav-link-lg collapse-btn">
      <!-- <tui-badge appearance="neutral" style="width: 50px;">{{currentValue}}</tui-badge> -->
      <!-- <tui-badge status="error" value="Custom template" class="tui-space_right-2">
      <span class="custom-content"></span>
    </tui-badge> -->

    @if (isMinutesDisplay) {
      <span tuiBadge class="tui-space_right-2" appearance="info"iconStart="@tui.clock">{{currentMinutes}}
        <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->

      </span>
    }
    @if (!isMinutesDisplay) {
      <span tuiBadge class="tui-space_right-2" appearance="info"iconStart="@tui.clock">{{currentValue}}
        <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->

      </span>
    }
  </div>
</li>
        <!--    <li> <a class="nav-link nav-link-lg-->
        <!--      collapse-btn" (click)="callFullscreen()">-->
        <!--        <i-feather name="maximize"></i-feather>-->
        <!--      </a>-->
        <!--    </li>-->
        <!--    <li class="dropdown dropdown-list-toggle" ngbDropdown>-->
        <!--      <a data-toggle="dropdown" class="nav-link nav-link-lg lang-toggle remove-caret" ngbDropdownToggle>-->
        <!--        <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" alt="Header Language" height="16">-->
        <!--        <img *ngIf="flagvalue === undefined" src="{{defaultFlag}}" alt="Header Language" height="16">-->
        <!--      </a>-->
        <!--      <div class="dropdown-menu header-dropdown dropdown-menu-right lang-dropdown-list pullDown" ngbDropdownMenu>-->
        <!--        <a href="javascript:void(0);" class="dropdown-item lang-item-list" *ngFor="let item of listLang"-->
        <!--          (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': langStoreValue === item.lang}">-->
        <!--          <img src="{{item.flag}}" alt="user-image" class="msr-1" height="12"> <span-->
        <!--            class="align-middle">{{item.text}}</span>-->
        <!--        </a>-->
        <!--      </div>-->
        <!--    </li>-->
        <!--li class="dropdown dropdown-list-toggle" ngbDropdown>
            <a class="nav-link nav-link-lg message-toggle remove-caret" data-toggle="dropdown" ngbDropdownToggle>
                <i-feather class="mailAnim1 collapse-btn" name="mail"></i-feather>
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-list header-dropdown pullDown" ngbDropdownMenu>
                <div class="dropdown-header">
                    Messages
                    <div class="float-end">
                        <a href="#" onClick="return false;">Mark All As Read</a>
                    </div>
                </div>
                <ng-scrollbar style="height: 250px" visibility="hover">
                    <div class="dropdown-list-content dropdown-list-message">
                        <a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-avatar
                text-white"> <img alt="image" class="rounded-circle" src="assets/images/users/user-1.png">
      </span> <span class="dropdown-item-desc"> <span class="message-user">John
    Deo</span>
    <span class="time messege-text">Please check your mail !!</span>
    <span class="time">2 Min Ago</span>
  </span>
</a>
<a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-avatar text-white">
  <img alt="image" class="rounded-circle" src="assets/images/users/user-2.png">
</span> <span class="dropdown-item-desc"> <span class="message-user">Sarah
Smith</span> <span class="time messege-text">Request for leave
application</span>
<span class="time">5 Min Ago</span>
</span>
</a>
<a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-avatar text-white">
  <img alt="image" class="rounded-circle" src="assets/images/users/user-5.png">
</span> <span class="dropdown-item-desc"> <span class="message-user">Jacob
Ryan</span> <span class="time messege-text">Your invoice is
generated.</span> <span class="time">12 Min Ago</span>
</span>
</a>
<a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-avatar text-white">
  <img alt="image" class="rounded-circle" src="assets/images/users/user-4.png">
</span> <span class="dropdown-item-desc"> <span class="message-user">Lina
Smith</span> <span class="time messege-text">hii John, I have upload
doc
related to task.</span> <span class="time">30
Min Ago</span>
</span>
</a>
<a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-avatar text-white">
  <img alt="image" class="rounded-circle" src="assets/images/users/user-3.png">
</span> <span class="dropdown-item-desc"> <span class="message-user">Jalpa
Joshi</span> <span class="time messege-text">Please do as specify.
Let me
know if you have any query.</span> <span class="time">1
Days Ago</span>
</span>
</a>
<a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-avatar text-white">
  <img alt="image" class="rounded-circle" src="assets/images/users/user-2.png">
</span> <span class="dropdown-item-desc"> <span class="message-user">Sarah
Smith</span> <span class="time messege-text">Client Requirements</span>
<span class="time">2 Days Ago</span>
</span>
</a>
</div>
</ng-scrollbar>
<div class="dropdown-footer text-center">
  <a href="#" onClick="return false;">View All <i class="fas fa-chevron-right"></i></a>
</div>
</div>
</li-->

<!--li class="dropdown dropdown-list-toggle" ngbDropdown>
<a class="nav-link nav-link-lg message-toggle remove-caret" data-toggle="dropdown" ngbDropdownToggle>
  <i-feather class="bell collapse-btn" name="bell"></i-feather>
</a>
<div class="dropdown-menu dropdown-menu-right dropdown-list header-dropdown pullDown" ngbDropdownMenu>
  <div class="dropdown-header">
    Notfications
    <div class="float-end">
      <a href="#" onClick="return false;">Mark All As Read</a>
    </div>
  </div>
  <ng-scrollbar style="height: 250px" visibility="hover">
    <div class="dropdown-list-content dropdown-list-icons">
      <a class="dropdown-item dropdown-item-unread" href="#" onClick="return false;"> <span class="dropdown-item-icon l-bg-orange text-white"> <i class="far fa-envelope"></i>
    </span> <span class="dropdown-item-desc"> You got new mail, please check. <span class="time">2 Min
  Ago</span>
</span>
</a>
<a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-icon l-bg-purple text-white"> <i class="fas fa-bell"></i>
</span> <span class="dropdown-item-desc"> Meeting with <b>John Deo</b> and <b>Sarah Smith </b> at
10:30 am <span class="time">10 Hours
Ago</span>
</span>
</a>
<a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-icon l-bg-green text-white"> <i class="far fa-check-circle"></i>
</span> <span class="dropdown-item-desc"> Sidebar Bug is fixed by Kevin <span class="time">12
Hours
Ago</span>
</span>
</a>
<a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-icon bg-danger text-white"> <i class="fas fa-exclamation-triangle"></i>
</span> <span class="dropdown-item-desc"> Low disk space error!!!. <span class="time">17 Hours
Ago</span>
</span>
</a>
                        <a class="dropdown-item" href="#" onClick="return false;"> <span class="dropdown-item-icon bg-info text-white"> <i class="fas
                fa-bell"></i>
</span> <span class="dropdown-item-desc"> Welcome to Oreva
template! <span class="time">Yesterday</span>
</span>
</a>
</div>
</ng-scrollbar>
<div class="dropdown-footer text-center">
  <a href="#" onClick="return false;">View All <i class="fas fa-chevron-right"></i></a>
</div>
</div>
</li-->

<!--    <li ngbDropdown class="dropdown dropdown-list-toggle"><a ngbDropdownToggle data-toggle="dropdown"-->
<!--        class="nav-link nav-link-lg message-toggle remove-caret">-->
<!--        <i-feather name="user" class="bell collapse-btn"></i-feather>-->
<!--      </a>-->
<!--      <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right dropdown-list header-dropdown pullDown">-->
<!--        <div class="dropdown-header">-->
<!--          Users-->
<!--          &lt;!&ndash; <div class="float-end">-->
<!--            <a href="#" onClick="return false;">Mark All As Read</a>-->
<!--          </div> &ndash;&gt;-->
<!--        </div>-->
<!--        <ng-scrollbar style="height: 370px" visibility="hover" class="people-list">-->
<!--          <div class="chat-search">-->
<!--            <input type="text" class="form-control" placeholder="Search..." />-->
<!--          </div>-->
<!--          <div class="m-b-20">-->
<!--            <div id="chat-scroll">-->
<!--              <ul class="chat-list list-unstyled m-b-0">-->
<!--                <li class="clearfix active">-->
<!--                  <img src="assets/images/users/user-4.png" alt="avatar">-->
<!--                  <div class="about">-->
<!--                    <div class="name">William Smith</div>-->
<!--                    <div class="status">-->
<!--                      <i class="material-icons offline">fiber_manual_record</i>-->
<!--                      left 7 mins ago-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--                <li class="clearfix ">-->
<!--                  <img src="assets/images/users/user-1.png" alt="avatar">-->
<!--                  <div class="about">-->
<!--                    <div class="name">Martha Williams</div>-->
<!--                    <div class="status">-->
<!--                      <i class="material-icons offline">fiber_manual_record</i>-->
<!--                      online-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--                <li class="clearfix">-->
<!--                  <img src="assets/images/users/user-2.png" alt="avatar">-->
<!--                  <div class="about">-->
<!--                    <div class="name">Joseph Clark</div>-->
<!--                    <div class="status">-->
<!--                      <i class="material-icons online">fiber_manual_record</i>-->
<!--                      online-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--                <li class="clearfix">-->
<!--                  <img src="assets/images/users/user-3.png" alt="avatar">-->
<!--                  <div class="about">-->
<!--                    <div class="name">Nancy Taylor</div>-->
<!--                    <div class="status">-->
<!--                      <i class="material-icons online">fiber_manual_record</i>-->
<!--                      online-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--                <li class="clearfix">-->
<!--                  <img src="assets/images/users/user-4.png" alt="avatar">-->
<!--                  <div class="about">-->
<!--                    <div class="name">Margaret Wilson</div>-->
<!--                    <div class="status">-->
<!--                      <i class="material-icons online">fiber_manual_record</i>-->
<!--                      online-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--                <li class="clearfix">-->
<!--                  <img src="assets/images/users/user-5.png" alt="avatar">-->
<!--                  <div class="about">-->
<!--                    <div class="name">Joseph Jones</div>-->
<!--                    <div class="status">-->
<!--                      <i class="material-icons offline">fiber_manual_record</i>-->
<!--                      left 30 mins ago-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--                <li class="clearfix">-->
<!--                  <img src="assets/images/users/user-1.png" alt="avatar">-->
<!--                  <div class="about">-->
<!--                    <div class="name">Jane Brown</div>-->
<!--                    <div class="status">-->
<!--                      <i class="material-icons offline">fiber_manual_record</i>-->
<!--                      left 10 hours ago-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--                <li class="clearfix">-->
<!--                  <img src="assets/images/users/user-2.png" alt="avatar">-->
<!--                  <div class="about">-->
<!--                    <div class="name">Eliza Johnson</div>-->
<!--                    <div class="status">-->
<!--                      <i class="material-icons online">fiber_manual_record</i>-->
<!--                      online-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--        </ng-scrollbar>-->
<!--        <div class="dropdown-footer text-center">-->
<!--          <a href="#" onClick="return false;">View All <i class="fas fa-chevron-right"></i></a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </li>-->

<li ngbDropdown>
  <a class="nav-link dropdown-toggle nav-link-lg nav-link-user" data-toggle="dropdown" ngbDropdownToggle>
    <img [src]="profileImage" alt="image" class="user-img-radious-style collapse-btn">
    <span class="d-sm-none d-lg-inline-block"></span></a>
    <div class="dropdown-menu dropdown-menu-right header-dropdown pullDown" ngbDropdownMenu>
      <div class="dropdown-title">Hello {{ currentUser?._value?.firstName }}..</div>
      <a (click)="navigateToUserProfile()" class="dropdown-item has-icon cursor-pointer pad-left-10">
                    <i class="far
              fa-user"></i> Profile
      </a>
      <div class="switch-role-scroll">
        <tui-data-list role="menu" size="s">
          <tui-opt-group label="Roles">
            @for (item of sortedUserRoles; track item) {
              <a #rla="routerLinkActive" (click)="switchRole(item)" [attr.aria-checked]="item === existingRoleSelected ? 'true' : 'false'" role="menuitemradio" routerLinkActive tuiOption> <span class="dropdown-item cursor-pointer active-inactive-font pad-left-0 ">{{ item.roleDisplayName }}</span>
              @if (item === existingRoleSelected) {
                <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
<span tuiAvatar="@tui.check" ></span>
              }
            </a>
          }
        </tui-opt-group>
      </tui-data-list>
    </div>
    <div class="dropdown-divider"></div>
    <a (click)="downloadPrintClient()" class="dropdown-item has-icon cursor-pointer pad-left-10">
      <i class="fa fa-download"></i>Print Tool</a>
      <div class="dropdown-divider"></div>
      <a (click)="DownloadDocument()" class="dropdown-item has-icon cursor-pointer pad-left-10">
        <i class="fas fa-file-pdf"></i>Download PDF</a>
        <div class="dropdown-divider"></div>
        <a (click)="logout()" class="dropdown-item has-icon text-danger" href="javascript:void(0);">
          <i class="fas fa-sign-out-alt"></i>
          Logout
        </a>
      </div>
    </li>
  </ul>
</nav>

<ng-template [(tuiDialog)]="isChangePasswordDialog" [tuiDialogOptions]="{ closable: false,size: 's'}">
  <div class="dialog-content">
    <h6 class="dialog-main-title">Change Password</h6>
    <hr class="title-line mt-1 mb-2">
    <div class="row mt-2">
      <form [formGroup]="resetPasswordForm">
        <div class="row">
          <div class="col-lg-12">
            <div class="col-12 mb-3">
              <tui-textfield  tuiTextfieldSize="m">
<label tuiLabel>
                Password
                </label>
<input placeholder="Password" tuiInput type="password" formControlName="password"/>
<tui-icon tuiPassword />

              </tui-textfield>
              @if (resetPasswordForm.get('password')?.errors?.required && resetPasswordForm.get('password')?.touched) {
                <div class="error-message">
                  Password is required !
                </div>
              }
              @if (resetPasswordForm.get('password')?.errors?.pattern && resetPasswordForm.get('password')?.touched) {
                <div class="error-message">
                  Password must contain at least one lowercase letter, one uppercase
                  letter, one digit, and one special character.
                </div>
              }
            </div>
            <div class="col-12  mb-3">
              <tui-textfield  tuiTextfieldSize="m">
<label tuiLabel>
                Confirm Password
                </label>
<input placeholder="Confirm Password" tuiInput type="password" formControlName="confirmPassword"/>
<tui-icon tuiPassword />

              </tui-textfield>
              @if (resetPasswordForm.get('confirmPassword')?.errors?.required && resetPasswordForm.get('confirmPassword')?.touched) {
                <div class="error-message">
                  Confirm Password is required !
                </div>
              }
              @if (resetPasswordForm.errors?.mismatch && resetPasswordForm.get('confirmPassword')?.touched) {
                <div class="error-message">
                  Password and confirm not match!
                </div>
              }
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="dialog-actions mt-1">
      <div class="col-12 mt-2">
        <div class="row mt-2">
          <div class="col-6">
            <button (click)="closechangePasswordDialog()" appearance="outline" class="tui-space_right-3 tui-space_bottom-3" size="s" tuiButton type="button">Cancel</button>
          </div>
          <div class="col-6 text-end">
            <button (click)="changePassword(resetPasswordForm.value)" [disabled]="resetPasswordForm.invalid" appearance="primary" class="tui-space_bottom-3" size="s" tuiButton type="button">Change
              Password
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
